import Head from 'next/head';
import { useRouter } from 'next/router';

import Banner from '../../components/BannerDefault';
import MetaTags from '../../components/MetaTags';
import {
  payloadContatos, payloadImagens, payloadListas, payloadSedes, payloadTextos,
} from '../../gql/empreendimentos';
import { findImage, imagemSizes } from '../../utils/ImageFindSizes';
import { getCollectionCMSGraphQL, getCollectionCMSUnity } from '../api/payloadCMS';

import style from './politica.module.scss';

const parse = require('html-react-parser');

export default function Privacidade({ politica }) {
  const router = useRouter();
  const rota = `https://hypeempreendimentos.com.br${router.asPath}`;

  if (!politica) return null;

  return (
    <div>
      <Head>
        <MetaTags
          data={{
            titulo: politica?.seo?.seo?.metaTitle,
            descricao: politica?.seo?.seo?.metaDescription,
            imagem: politica?.seo?.seo?.ogImage?.url,
            rota,
          }}
        />
      </Head>

      <Banner
        image={{ src: imagemSizes(findImage(politica?.imagens, 'banner-principal')) }}
        width='100%'
        height='70vh'>
        <h1>{politica?.textos?.find((txt) => txt.referencia === 'politica-de-privacidade-titulo-banner')?.texto.conteudo}</h1>
      </Banner>
      <div className={style.section}>
        {parse(politica?.textos?.find((txt) => txt.referencia === 'politica-de-privacidade-clausulas')?.texto.conteudo)}
      </div>
    </div>
  );
}

export async function getStaticProps() {
  const paginas = await getCollectionCMSUnity('paginas/pagina/politica-de-privacidade');
  const politica = paginas;

  const imagens: any = await getCollectionCMSGraphQL(
    'Imagens',
    payloadImagens({
      limit: 6,
      titulo: ['logo', 'facebook_icon', 'instagram_icon', 'youtube_icon', 'linkedin_icon', 'logo_escura'],
    }),
  );
  const logo = imagens?.find((img: any) => img?.titulo === 'logo')?.url;

  const listas: any = await getCollectionCMSGraphQL(
    'Listas',
    payloadListas({
      limit: 1,
      tituloLista: 'Site - header',
    }),
  );
  const routes = listas?.find((lt: any) => lt.tituloLista === 'Site - header')?.itens;

  const footerIcons = imagens?.filter((img: any) => ['facebook_icon', 'instagram_icon', 'youtube_icon', 'linkedin_icon', 'logo_escura'].includes(img?.titulo),
  );

  const getSedes: any = await getCollectionCMSGraphQL(
    'Sedes',
    payloadSedes({
      limit: 2,
      nomes: ['Sede 1', 'Americana'],
    }),
  );
  const address = getSedes?.filter((sede: any) => ['Sede 1', 'Americana'].includes(sede?.nome));

  const socialMedia = getSedes
    ?.filter((sede) => ['Sede 1'].includes(sede?.nome))
    .map(({
      instagram, youtube, facebook, linkedin,
    }) => ({
      instagram,
      youtube,
      facebook,
      linkedin,
    }))[0];

  const getContatos: any = await getCollectionCMSGraphQL(
    'Contatos',
    payloadContatos({
      limit: 1,
      tituloLista: 'Geral',
    }),
  );
  const contact = getContatos?.filter((list: any) => ['Geral'].includes(list?.tituloLista))?.[0]?.contatos || { contatos: [] };

  const textos: any = await getCollectionCMSGraphQL(
    'Textos',
    payloadTextos({
      limit: 1,
      titulo: 'Copyright',
    }),
  );
  const copy = textos?.find((txt: any) => txt?.titulo === 'Copyright')?.conteudo;

  const headerData = { logo, routes };
  const footerData = {
    routes,
    logo,
    footerIcons,
    address,
    contact,
    copy,
    socialMedia,
  };

  return { props: { politica, headerData, footerData }, revalidate: Number(process.env.REVALIDATE_INTERVAL) };
}
